import { getLanguageDirection } from '../../../../app/javascript/dashboard/components/widgets/conversation/advancedFilterItems/languages';

/**
 * Legacy Orbex set dir='rtl' and lang='fa' on the document unconditionally, so
 * an English dashboard was still laid out right-to-left. Direction is derived
 * from the locale the dashboard has actually selected instead, reusing
 * upstream's own RTL language list, so LTR locales keep native behaviour.
 */
export const applyDashboardDirection = locale => {
  const root = document?.documentElement;

  if (!root) return false;

  const languageCode = String(locale || '').split(/[-_]/)[0];
  const isRTL = getLanguageDirection(languageCode);

  root.setAttribute('dir', isRTL ? 'rtl' : 'ltr');

  if (languageCode) {
    root.setAttribute('lang', languageCode);
  }

  return isRTL;
};
